<template>
    <div class="list_nav_wrap toggle-nav">
        <h1 class="list_nav_title">
            <label>{{ keyName }}</label>
        </h1>
        <div class="sc-option" data-ui="dropdown" id="brand_option" style="z-index: 994;">
            <div class="sc-option-hd"
                @click="show = true">
                <div class="sc-option-content">
                    {{ activeName }}
                </div>
                <div class="sc-option-action">
                    <i></i>
                </div>
            </div>
            <ul v-if="show"
                class="sc-option-list" style="top: 25px;">
                <li v-for="item in list">
                    <a @click="doSelect(item.value)"
                    :id-data="item.value">
                        {{ item.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    let formBean = window._qiwa.page_global.formBean;
    export default {
        data() {
            return {
                key: 'country',
                keyName: '国别',
                show: false,
                activeName: formBean.countryName || '请选择国别',
                list: [{
                    value: 'car_country_germany',
                    name: '德国'
                }, {
                    value: 'car_country_japan',
                    name: '日本'
                }, {
                    value: 'car_country_america',
                    name: '美国'
                }, {
                    value: 'car_country_korea',
                    name: '韩国'
                }, {
                    value: 'car_country_french',
                    name: '法国'
                }, {
                    value: 'car_country_england',
                    name: '英国'
                }, {
                    value: 'car_country_italia',
                    name: '意大利'
                }, {
                    value: 'car_country_Sweden',
                    name: '瑞典'
                }, {
                    value: 'car_country_china',
                    name: '中国'
                }, {
                    value: false,
                    name: '不限'
                }]
            };
        },
        methods: {
            doSelect(value) {
                if (value) {
                    locationObj.s(this.key, value).s('index', null).go();
                } else {
                    locationObj.s(this.key, null).s('index', null).go();
                }
            }
        },
        mounted() {
            let $ = window.$;
            $('body').click((event) => {
                if (!$(event.target).closest('.sc-option').length) {
                    this.show = false;
                }
            });
        }
    };
</script>

<style lang="less" scoped>
    a {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// NavCountry.vue?64eea102